import { useRef } from 'react';

export function useScrollToPhotos() {
	const photosRef = useRef(null);
	const executeScroll = () => photosRef.current?.scrollIntoView();

	return [photosRef, executeScroll];
}
